module.exports = __webpack_public_path__ + "img/produits.d5a39851.jpg";